import { FileText, MessageSquare, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateHubspotCustomFieldsFillUpAr: TemplateAr = {
  name: 'أتمتة تعبئة حقول HubSpot المخصصة بالذكاء الاصطناعي',
  description:
    'تعبئة حقول HubSpot المخصصة تلقائياً أثناء المحادثات، وإنهاء الإدخال اليدوي للبيانات على فريق الدعم.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'العميل' },
    { icon: Sparkles, label: 'الـ AI يستخرج' },
    { icon: FileText, label: 'الحقول معبّأة', final: true },
  ],
  detailDescription: {
    paragraph1:
      'خلّ حقول HubSpot المخصصة تتعبّى وموظفك يتكلم مع العميل. الـ AI يستخرج المعلومة من المحادثة، ويحدد نقاط البيانات الأساسية، ويملأ الخصائص المخصصة لحظياً. والإدخال اليدوي للبيانات يخلص.',
    paragraph2:
      'بيانات الحقول تتزامن مباشرة مع جهات الاتصال والتذاكر في HubSpot، ومعها سجل تدقيق كامل. والنظام يشتغل مع سير عمل HubSpot والأتمتة اللي عندك أصلاً. والـ AI يتأقلم مع إعدادات HubSpot عندك ومع تعريفات الخصائص المخصصة.',
  },
  benefits: [
    'موظفك يخلّص من الإدخال اليدوي للبيانات',
    'الحقول تتعبّى بنفس الطريقة كل مرة',
    'وقت معالجة التذكرة ينزل',
    'بيانات الـ CRM عندك تصير أنظف',
    'سجل تدقيق كامل لأغراض الامتثال',
    'يشتغل مع كل خصائص HubSpot المخصصة',
  ],
};
